import { Moment } from "moment";

export default class Business implements IBusiness {
  public id!: string;
  public nome!: string;
  public cnpj!: string;
  public imagemUrl!: string;
  public principal!: string;
  public quantidade!: number;
  public dataCriacao!: Moment;

  constructor(param: IBusiness) {
    Object.assign(this, param);
  }
}

interface IBusiness {
  id: string;
  nome: string;
  cnpj: string;
  imagemUrl: string;
  principal: string;
  quantidade: number;
  dataCriacao: Moment;
}
